export default __webpack_public_path__ + "static/media/redo__1_-removebg-preview.51cfbdf5.png";